<template>
  <div id="app">
    <Header></Header>

    <!-- <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :key="$route.fullPath"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      :key="$route.fullPath"
    ></router-view> -->
    <keep-alive>
      <router-view :key="$route.fullPath"></router-view>
    </keep-alive>
    <!-- 侧边栏 -->
    <!-- 二维码 -->
    <div
      class="fixed_base fix1"
      @mouseenter="add_hover3"
      @mouseleave="reset_hover3"
    >
      <img class="fixImg" :src="code_img" alt="" />
    </div>
    <!-- 电话 -->
    <div
      class="fixed_base fix2"
      @mouseenter="add_hover2"
      @mouseleave="reset_hover2"
    >
      <img :class="hover2className" :src="phone_img" alt="" />
      <div class="phone_box">
        <a href="tel:020-85165995" style="color: #ffffff">{{
          contactData.fax
        }}</a>
      </div>
    </div>
    <!-- 返回顶部 -->
    <div class="fixed_base fix3" @click="returnTop" style="margin-top: 10px">
      <img class="fixImg" src="./assets/img/20x20_top.png" alt="" />
    </div>
    <!-- 二维码图片 -->
    <div class="two_code" v-show="showCode">
      <div class="code_1">
        <img :src="img_api + contactData.qrCode" alt="" />
      </div>
      <div class="code_1">
        <img :src="img_api + contactData.video" alt="" />
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import { getHeadBanner, getContactUs } from "@/server/https";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      hover2className: "fixImg",
      phone_img: require("./assets/img/20x20_phone_blue.png"),
      code_img: require("./assets/img/20x20_erweima_blue.png"),
      showCode: false,
      contactData: {},
      img_api: "https://www.gdyuanwo.com/gdyuanwo/",
    };
  },
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    getHeadBanner().then((res) => {
      this.headList = res.data.body.headList;
      this.$store.commit("getHeadList", res.data.body.headList);
    });
    getContactUs().then((res) => {
      this.contactData = res.data.body.contactUs;
    });
  },
  methods: {
    returnTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    add_hover2() {
      this.hover2className = "hover2";
      this.phone_img = require("./assets/img/20x20_phone_white.png");
    },
    reset_hover2() {
      this.hover2className = "fixImg";
      this.phone_img = require("./assets/img/20x20_phone_blue.png");
    },
    add_hover3() {
      this.showCode = true;
      this.code_img = require("./assets/img/20x20_erweima_white.png");
    },
    reset_hover3() {
      this.showCode = false;
      this.code_img = require("./assets/img/20x20_erweima_blue.png");
    },
  },
};
</script>

<style >
.fixed_base {
  position: fixed;
  width: 56px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);
  border-radius: 28px;
  cursor: pointer;
  z-index: 2200;
}

.fixImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.phone_box {
  display: none;
}

.fix1:hover {
  background-color: #13489d;
}
.fix2:hover{
  padding-left: 110px;
  border-radius: 40px;
  background-color: #13489d;

}
.fix2:hover .phone_box {
  display: block;
  position: absolute;
  top: 17px;
  left: 45px;
  bottom: 0;
  margin: auto;
  font-weight: bold;
  color: #ffffff;
}
.hover2 {
  position: absolute;
  top: 0;
  left: 20px;
  bottom: 0;
  margin: auto;
}

.fix1 {
  right: 10px;
  top: 400px;
}

.fix2 {
  right: 10px;
  top: 463px;
}

.fix3 {
  right: 10px;
  top: 530px;
}

/* 二维码 */
.two_code {
  display: flex;
  position: fixed;
  top: 350px;
  right: 70px;
  z-index: 2200;
}

.code_1 {
  width: 100px;
  height: 100px;
  margin: 5px;
  border: 4px solid #13489d;
}

.code_1 img {
  width: 100%;
  height: 100%;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #13489d;
  color: #fff;
}
</style>
